<template>
  <div>
    <Standards class="mb-2" />
    <CouponStandards class="mb-2" />
    <LegionellaStandards class="mb-2" />
  </div>
</template>


<script>
import Standards from '@/views/admin/management/templates-norms/Standards';
import CouponStandards from '@/views/admin/management/templates-norms/CouponStandards';
import LegionellaStandards from '@/views/admin/management/templates-norms/LegionellaStandards';

export default {
    components: {
        Standards,
        CouponStandards,
        LegionellaStandards,
    },
};
</script>
